import React from 'react';
import PropTypes from 'prop-types';
import { HiCheck } from 'react-icons/hi';
import Card from 'partial/components/Card';
import Button from 'partial/components/Button';

function Intro({ onNext }) {
  return (
    <Card>
      <div className="p-12 max-w-2xl mx-auto">
        <div className="space-y-3 mb-5 border-b pb-5">
          <div className="title-h1 text-center">
            Welcome to DST Biller Portal
          </div>
          <p className="text-base text-gray-800">
            Before you can start getting paid with DST Biller Portal, we need to
            learn more about your business as part of our know-your-customer
            (KYC) process.
          </p>
        </div>
        <ul className="space-y-2 mb-4">
          <li className="flex space-x-2">
            <HiCheck className="w-5 h-5 flex-shrink-0 text-green-600" />
            <p className="text-base text-gray-800">
              Please provide the necessary information and documents to avoid
              delays in your activation.
            </p>
          </li>
          <li className="flex space-x-2">
            <HiCheck className="w-5 h-5 flex-shrink-0 text-green-600" />
            <p className="text-base text-gray-800">
              Upon submission, please give our team up to 7 working days to
              review your submission and respond. You may receive follow up
              messages through e-mail or SMS.
            </p>
          </li>
        </ul>
        <div className="space-y-3 mb-5">
          <p className="text-base text-gray-800">
            If you have any inquiries, you can send us an email to{' '}
            <span className="text-primary-400 font-normal">
              merchant@dst.com.bn
            </span>
          </p>
          <p className="text-base">
            Press the &quot;
            <span className="font-semibold">
              Continue to General Information
            </span>
            &quot; if you&apos;re ready to proceed!
          </p>
        </div>
        <div className="mt-3 border-t pt-5 flex justify-center">
          <Button primary size="lg" onClick={onNext}>
            Continue to General Information
          </Button>
        </div>
      </div>
    </Card>
  );
}

Intro.propTypes = {
  onNext: PropTypes.func.isRequired,
  // onBack: PropTypes.func.isRequired,
};

export default Intro;
